import { productPrices } from "./product-prices-de.i18n";

export const de = {
  productPrices,
};
